<template>
  <b-modal :id="modalId" modal-class="modal-mobile-fullscreen" centered size="md"
           @ok="allowMarketingCommunications(true)"
           @close="allowMarketingCommunications(false)"
           @cancel="allowMarketingCommunications(false)">
    <div class="d-block text-center">
      <Icon name="grBell" width="36" class="mb-3"/>

      <h1 class="modal-title pb-2">
        {{ $t('modal_marketing_consent.title_alaska') }}
      </h1>
      <p class="py-4 px-4">
        {{ $t('modal_marketing_consent.txt_alaska') }}

      </p>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 order-sm-1 ml-sm-2 mb-2 mb-sm-0">
            <button-with-spinner class="btn btn-primary btn-block" @click="ok" :loading="loading">
              {{ $t('modal_marketing_consent.btn_ok') }}
            </button-with-spinner>
          </div>
          <div class="flex-grow-1 order-sm-0 mr-sm-2">
            <b-button variant="link" size="sm" block @click="cancel">
              {{ $t('modal_marketing_consent.btn_cancel') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>
import ButtonWithSpinner from '@/components/ButtonWithSpinner'
import UserService from "@/services/User";

export default {
  components: {
    ButtonWithSpinner,
  },

  props: {
    modalId: {type: String, required: false, default: 'modal-marketing-consent'},
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    allowMarketingCommunications(allowMarketing) {
      this.loading = true
      UserService.updateUser({'consent_3rd_party_marketing': allowMarketing}).then(() => {
        this.$bvModal.hide(this.modalId)
      }).finally(() => this.loading = false)
    }
  }

}
</script>
